 import { useGetHttp } from "../../../../hooks/http/http.hook";
import type { IProposal } from "../../../types/models/proposal.modals";

 interface IResponse {
  proposal: IProposal;
}

 export function useGetProposalByIdHttp() {
  return useGetHttp<IResponse>({
    path: "/brand/campaigns/proposals/:proposalId",
  });
}
